import styled from 'styled-components';
import { color, fontSize, fontWeight, radius, spacing } from '../../../theme';

export const StyledCard = styled.div`
  background-color: ${color('sand_100')};
  border-radius: ${radius('lg')};
  padding: ${spacing('xl')} ${spacing('lg')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
`;

export const StyledBadge = styled.div`
  background-color: ${color('navy_400')};
  border-radius: ${radius('full')};
  padding: ${spacing('xs2')} ${spacing('lg')};
  margin-left: ${spacing('xl3')};
  margin-right: ${spacing('xl3')};
  color: ${color('text_white')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  text-align: center;
`;

export const StyledTitle = styled.div`
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
`;

export const StyledTechs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing('sm')};
  margin-top: ${spacing('sm')};
`;

export const StyledTechItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  font-weight: ${fontWeight('extraBold')};

  img {
    width: 2.15rem;
    height: auto;
    filter: grayscale(100%);
  }
`;

export const StyledInfo = styled.div`
  display: flex;
  gap: ${spacing('md')};
  border-top: 1px solid ${color('midnight_200')};
  border-bottom: 1px solid ${color('midnight_200')};
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};
`;

export const StyledInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs2')};
  font-weight: ${fontWeight('extraBold')};
`;

export const StyledMembers = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};

  &.extra {
    display: none;

    &.show {
      display: flex;
    }
  }
`;

export const StyledMemberItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('sm')};
  font-weight: ${fontWeight('black')};

  img {
    flex-shrink: 0;
    width: ${spacing('xl3')};
    height: ${spacing('xl3')};
    display: block;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledMemberExperience = styled.div`
  background-color: ${color('midnight_150')};
  border-radius: ${radius('full')};
  padding: ${spacing('xs2')} ${spacing('xs')};
  color: ${color('text_subtle')};
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('extraBold')};
  margin-top: ${spacing('xs')};
`;

export const StyledShowMore = styled.button`
  background: transparent;
  border: 0;
  color: ${color('navy_400')};
  text-transform: uppercase;
  font-weight: ${fontWeight('medium')};
  display: inline-flex;
  align-self: center;
  align-items: center;
  gap: ${spacing('xs')};
  cursor: pointer;
  position: relative;
  transition: 0.3s;

  &.hide {
    display: none;
  }

  &::before,
  &::after {
    content: '';
    width: ${spacing('sm')};
    height: 1px;
    background-color: ${color('navy_400')};
  }

  &:hover {
    color: ${color('navy_600')};
    &::before,
    &::after {
      background-color: ${color('navy_600')};
    }
  }
`;
